import Vue from "vue";
import Vuex from "vuex";
import registrationAuth from "./auth/registration";
import registrationMasters from "./masters/masters";
import contactUs from "./other/contactus";
import subscribeUs from "./other/subscribe";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    registrationAuth,
    registrationMasters,
    contactUs,
    subscribeUs
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
});
export default store;
